import { useMutation, useQueryClient } from "react-query";
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from '../../global_state'
import { activate_recruiter } from "../../services/admin";


const  useActivateRecruiter = () => {
  const queryClient = useQueryClient()
  const set_error = useSetRecoilState(error_message)
  const set_success = useSetRecoilState(success_message)

  return  useMutation((email)=>activate_recruiter(email), {
      onSuccess: data => {
        set_success('Successfully activated recruiter account!')
        setTimeout(() => {
          set_success('')
        }, 4000);
        queryClient.invalidateQueries('get_invitations')
      },
      onError: () => {
        set_error('Problem activating recruiter account!')
        setTimeout(() => {
          set_error('')
        }, 4000);
      }
  })
}

export default useActivateRecruiter;